module.exports = __webpack_public_path__ + "img/ps4_controller.034432e5.png";